import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { VehicleService } from '../../../services/vehicle.service';

@Component({
    selector: 'app-vehicles',
    templateUrl: './vehicles.component.html',
    encapsulation: ViewEncapsulation.None
})

export class VehiclesComponent implements OnInit {

    constructor(private vehicleService: VehicleService) { }

    titleTextFilter = true;
    tableInfo = "hide-info";
    vehicleList: any = [];
    filteredVehicleList: any = [];

    ngOnInit(): void {
        this.getVehicles();
    }

    getVehicles() {
        this.vehicleService.geAlltVehicles(false).subscribe(data => {
            this.vehicleList = data;
            this.refreshList();
        });
    }

    refreshList() {
        if (this.titleTextFilter)
            this.filteredVehicleList = this.vehicleList.filter((v) => v.VehicleStatus === 'Ativo')
        else
            this.filteredVehicleList = this.vehicleList.filter((v) => v.VehicleStatus !== 'Ativo')
    }

    setTitleTextFilter() {
        this.titleTextFilter = !this.titleTextFilter;
        this.refreshList();
    }

    setTableShowInfo() {
        this.tableInfo = "show-info";
    }

    setTableHideInfo() {
        this.tableInfo = "hide-info";
    }
}
